import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from '../constants/Breakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
export const PageSection = styled.section.withConfig({
  displayName: "PageSection",
  componentId: "mlrp6d-0"
})(({
  theme,
  use,
  hideOverflow
}) => {
  return {
    inlineSize: '100%',
    position: 'relative',
    marginBlockEnd: theme.space[1400],
    paddingInline: theme.space[0],
    overflow: hideOverflow ? 'hidden' : 'visible',
    backgroundColor: use === 'shaded' ? theme.color['fill-field-default'] : undefined,
    [trellisBreakpoint.tablet]: {
      paddingInline: theme.space[300]
    }
  };
});
export const SectionHeader = styled.div.withConfig({
  displayName: "PageSection__SectionHeader",
  componentId: "mlrp6d-1"
})(({
  theme,
  maxInlineSize
}) => {
  return {
    textAlign: 'center',
    maxWidth: maxInlineSize,
    marginBlockEnd: theme.space[800],
    marginInline: 'auto'
  };
});
export const SectionTitle = props => {
  return /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
    as: "h2",
    typography: "heading-400",
    marginBlockEnd: "200",
    marginBlockStart: "0"
  }));
};
export const SectionSubTitle = props => {
  return /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
    as: "p"
  }));
};
export const SectionContainer = props => {
  return /*#__PURE__*/_jsx(Flex, Object.assign({}, props, {
    maxInlineSize: "1130px",
    marginInline: "auto",
    inlineSize: "100%",
    flexDirection: "column"
  }));
};